import {useEffect, useState} from 'react';

export const useScrollHeight = (height: number) => {
    const [isHit, setIsHit] = useState(false);
    useEffect(() => {
        const handleScroll = () => {
            const scrollPosition = window.scrollY;

            setIsHit(scrollPosition >= height);
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return isHit;
};
